<!--
    @修改人：黎柏祺
    @修改时间：2018-12-17
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @负责人: 黎柏祺
    @创建时间: 2018-04-28
    @版本: v1.0.16
    @描述: 指标采集配置
-->
<template>
  <div class="kpiInterval__content">
    <el-form ref="form" :model="form" lable-width="80px" input-width="200px">
      <el-form-item :label="$t('logComponentManage.frequency')">
        <g-select :list="frequencyList"  v-model="form.kpiInterval"></g-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="e_save" v-g-rac="gRac('kpiInterval_save')">{{ $t('common.save') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import kpiIntervalBiz from '@/logic/systemSetting/kpiIntervalBiz.js'
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  export default {
    mixins: [rac, dic],
    data () {
      return {
        form: {
          kpiInterval: ''
        },
        frequencyList: {}
      }
    },
    props: ['siteCode'],
    methods: {
      async waitTimerTpye () {
        await this.dGetDictionaryByCode('timerTpye')
        this.frequencyList = { ...this.dDictionary.timerTpye }
        this.form.kpiInterval = Object.keys(this.frequencyList)[0]
      },
      e_save () {
        kpiIntervalBiz.save({ kpiInterval: Number(this.form.kpiInterval), siteCode: this.siteCode }).then(() => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
        })
      }
    },
    mounted () {
      this.waitTimerTpye()
    }
  }
</script>
